<div class="p-4" style="width: 600px">
  @if(showErrorMessage){
  <div class="error-msg">
    <div>Lost Network Connection. Do Not Refresh This Page.</div>
    <div>Retrying Again in 5 Minutes.</div>
  </div>
  }

  <button
    tbs-button
    tbsType="solid"
    class="col-12 mb-2"
    [disabled]="isUploadStarted || isUploadAllDisabled"
    (click)="uploadAll()"
  >
    Upload All
  </button>

  @if(!isUploadStarted) {
  <tbs-upload
    tbsMode="drag"
    [tbsDirectory]="true"
    [tbsMultiple]="true"
    (tbsChange)="onFolderSelected($event)"
  >
    <div class="m-3 upload-area">
      <tbs-icon icon="calcite:upload-24" size="medium"></tbs-icon>Drag Folder Here or
      <u>Browse</u>
    </div>
  </tbs-upload>
  } 
  
  @for (task of tasks; track task.id) {
  <app-folder-task-item
    [task]="task"
    [missionCreationResult]="missionCreationResult"
    (uploadEvent)="onUploadEvent($event, task)"
    (remove)="onTaskRemove(task.id)"
    (dataTypeChange)="onDataTypeChange($event, task)"
  ></app-folder-task-item>
  }
</div>
